import { render, staticRenderFns } from "./service-choosen.vue?vue&type=template&id=7ba5f5d9&"
import script from "./service-choosen.vue?vue&type=script&lang=js&"
export * from "./service-choosen.vue?vue&type=script&lang=js&"
import style0 from "./service-choosen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports